var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentcreationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-329.000000, -6334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-23",
    transform: "translate(329.000000, 6334.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(2.345853, 3.019324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#935AFE",
    x: 0,
    y: 0,
    width: 11.1111111,
    height: 12.8527774,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07355472,3.62375157 C8.3496971,3.62375157 8.57355472,3.84760919 8.57355472,4.12375157 C8.57355472,4.36921146 8.39667956,4.57335994 8.16343035,4.6156959 L8.07355472,4.62375157 L3.57553904,4.62375157 C3.29939666,4.62375157 3.07553904,4.39989394 3.07553904,4.12375157 C3.07553904,3.87829168 3.2524142,3.6741432 3.48566341,3.63180724 L3.57553904,3.62375157 L8.07355472,3.62375157 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07355472,6.54483735 C8.3496971,6.54483735 8.57355472,6.76869497 8.57355472,7.04483735 C8.57355472,7.29029724 8.39667956,7.49444572 8.16343035,7.53678168 L8.07355472,7.54483735 L3.57553904,7.54483735 C3.29939666,7.54483735 3.07553904,7.32097972 3.07553904,7.04483735 C3.07553904,6.79937746 3.2524142,6.59522898 3.48566341,6.55289302 L3.57553904,6.54483735 L8.07355472,6.54483735 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82454688,9.46592313 C6.10068925,9.46592313 6.32454688,9.68978075 6.32454688,9.96592313 C6.32454688,10.211383 6.14767172,10.4155315 5.91442251,10.4578675 L5.82454688,10.4659231 L3.57553904,10.4659231 C3.29939666,10.4659231 3.07553904,10.2420655 3.07553904,9.96592313 C3.07553904,9.72046324 3.2524142,9.51631476 3.48566341,9.4739788 L3.57553904,9.46592313 L5.82454688,9.46592313 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.44320601,10.7026024 L9.58128929,10.7026024 C9.85743167,10.7026024 10.0812893,10.92646 10.0812893,11.2026024 C10.0812893,11.3050462 10.0498218,11.4050178 9.99114413,11.488992 L9.40796406,12.3235864 C9.24979545,12.549943 8.93807619,12.6052202 8.71171961,12.4470516 C8.66045554,12.4112304 8.61636665,12.3661098 8.58174061,12.314031 L8.0268374,11.4794366 C7.87394609,11.2494825 7.93641777,10.9391251 8.1663718,10.7862337 C8.24839757,10.7316966 8.34470462,10.7026024 8.44320601,10.7026024 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E966FF",
    transform: "translate(9.025489, 11.813713) rotate(31.000000) translate(-9.025489, -11.813713) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5788577,3.89478104 C12.2241661,3.89478104 12.747292,4.4179069 12.747292,5.06321535 L12.747292,9.7369526 C12.747292,10.3822611 12.2241661,10.9053869 11.5788577,10.9053869 C10.9335492,10.9053869 10.4104233,10.3822611 10.4104233,9.7369526 L10.4104233,5.06321535 C10.4104233,4.4179069 10.9335492,3.89478104 11.5788577,3.89478104 Z",
    id: "\\u77E9\\u5F62",
    fill: "#E966FF",
    transform: "translate(11.578858, 7.400084) rotate(31.000000) translate(-11.578858, -7.400084) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5200267,2.74018764 L14.4937219,2.74018764 C14.8701519,2.74018764 15.1753086,3.04534439 15.1753086,3.42177432 C15.1753086,3.79820425 14.8701519,4.103361 14.4937219,4.103361 L13.5200267,4.103361 C13.1435967,4.103361 12.83844,3.79820425 12.83844,3.42177432 C12.83844,3.04534439 13.1435967,2.74018764 13.5200267,2.74018764 Z",
    id: "\\u77E9\\u5F62",
    fill: "#FF76FB",
    transform: "translate(14.006874, 3.421774) rotate(31.000000) translate(-14.006874, -3.421774) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentcreationIcon);
export default __webpack_public_path__ + "static/media/Intelligentcreation_icon.9816cc1ed214043f4f2a45c4f5842220.svg";
export { ForwardRef as ReactComponent };